// TODO: Update message to show right time frames based on NOT-status
export default {
  speedSelectionTooltipData: {
    title: 'These are the speed options available at your new address',
    modalHeading: 'What sort of speeds can I expect at my new address?',
    hasIcon: true
  },
  connectDateTooltipInstalledOnt: {
    title: 'More information on connection dates',
    modalHeading: 'How long does it take to get connected?',
    modalDescription: 'Fibre is already installed so once you receive your modem you can be connected quickly. You won’t need a technician to get you connected and we’ll be in touch as soon as we know when your connection will be switched on.​',
    hasIcon: true
  },
  connectDateTooltipNoOnt: {
    title: 'More information on connection dates',
    modalHeading: 'How long does it take to get connected?',
    modalDescription: 'If you signed up to one of our fibre plans and this is your first time ordering it at your place, it can take 4 – 6 weeks, but sometimes up to 8 weeks. In the meantime, we’ll be with you during the whole installation process and we can also get you connected to a temporary ADSL connection if it’s available at your address.',
    hasIcon: true
  },
  connectDateTooltipDSLOnly: {
    title: 'More information on connection dates',
    modalHeading: 'How long does it take to get connected?',
    modalDescription: 'In most cases, it will take up to 5 to 7 working days to get you connected with Skinny Fixed-line Broadband. We can’t provide an exact date as the process involves third parties, but we’ll do our best to be in touch as soon as we know when your connection will be switched on. Most connections won’t even need a technician to come around but in some cases, one may need to pay a visit to make sure you’re all set.​',
    hasIcon: true
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/Change/MoveTooltipContent.js
 **/